import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";
import { API_BASE_URI } from "../ApiCall";
import { PettyCashRequisitionActionTypes } from "./PettyCashRequisition.type";

export function* fetchAllPettyCashRequisitionSaga(action: any): any {
  try {
    const response = yield axios.get(`${API_BASE_URI}/petty-cash-requisition`);
    yield put({
      type: PettyCashRequisitionActionTypes.FETCH_ALL_PETTY_CASH_REQUISITION_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: PettyCashRequisitionActionTypes.FETCH_ALL_PETTY_CASH_REQUISITION_FAILURE,
      payload: error,
    });
  }
}

export function* fetchOnePettyCashRequisitionSaga(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/petty-cash-requisition/${action?.payload?.id}`
    );
    yield put({
      type: PettyCashRequisitionActionTypes.FETCH_ONE_PETTY_CASH_REQUISITION_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: PettyCashRequisitionActionTypes.FETCH_ONE_PETTY_CASH_REQUISITION_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllPettyCashRequisition() {
  yield takeLatest(
    PettyCashRequisitionActionTypes.FETCH_ALL_PETTY_CASH_REQUISITION,
    fetchAllPettyCashRequisitionSaga
  );
}

export function* watcherFetchOnePettyCashRequisition() {
  yield takeLatest(
    PettyCashRequisitionActionTypes.FETCH_ONE_PETTY_CASH_REQUISITION,
    fetchOnePettyCashRequisitionSaga
  );
}
